import axios from 'axios';
import { toast } from 'sonner';

const GEOLOCATION_API = 'https://validationapi.thetechmenders.com/api/GeoLocation/GetGeoLocation';
const LEAD_API = 'https://leadapi.crmbytes.com/api/Lead/AddLead';

let cachedGeoData = null;

export const countryCodes = [
  { code: '+1', country: 'USA/Canada', dialCode: 1 },
  { code: '+7', country: 'Russia/Kazakhstan', dialCode: 7 },
  { code: '+20', country: 'Egypt', dialCode: 20 },
  { code: '+27', country: 'South Africa', dialCode: 27 },
  { code: '+30', country: 'Greece', dialCode: 30 },
  { code: '+31', country: 'Netherlands', dialCode: 31 },
  { code: '+32', country: 'Belgium', dialCode: 32 },
  { code: '+33', country: 'France', dialCode: 33 },
  { code: '+34', country: 'Spain', dialCode: 34 },
  { code: '+36', country: 'Hungary', dialCode: 36 },
  { code: '+39', country: 'Italy', dialCode: 39 },
  { code: '+40', country: 'Romania', dialCode: 40 },
  { code: '+41', country: 'Switzerland', dialCode: 41 },
  { code: '+43', country: 'Austria', dialCode: 43 },
  { code: '+44', country: 'UK', dialCode: 44 },
  { code: '+45', country: 'Denmark', dialCode: 45 },
  { code: '+46', country: 'Sweden', dialCode: 46 },
  { code: '+47', country: 'Norway', dialCode: 47 },
  { code: '+48', country: 'Poland', dialCode: 48 },
  { code: '+49', country: 'Germany', dialCode: 49 },
  { code: '+51', country: 'Peru', dialCode: 51 },
  { code: '+52', country: 'Mexico', dialCode: 52 },
  { code: '+53', country: 'Cuba', dialCode: 53 },
  { code: '+54', country: 'Argentina', dialCode: 54 },
  { code: '+55', country: 'Brazil', dialCode: 55 },
  { code: '+56', country: 'Chile', dialCode: 56 },
  { code: '+57', country: 'Colombia', dialCode: 57 },
  { code: '+58', country: 'Venezuela', dialCode: 58 },
  { code: '+60', country: 'Malaysia', dialCode: 60 },
  { code: '+61', country: 'Australia', dialCode: 61 },
  { code: '+62', country: 'Indonesia', dialCode: 62 },
  { code: '+63', country: 'Philippines', dialCode: 63 },
  { code: '+64', country: 'New Zealand', dialCode: 64 },
  { code: '+65', country: 'Singapore', dialCode: 65 },
  { code: '+66', country: 'Thailand', dialCode: 66 },
  { code: '+81', country: 'Japan', dialCode: 81 },
  { code: '+82', country: 'South Korea', dialCode: 82 },
  { code: '+84', country: 'Vietnam', dialCode: 84 },
  { code: '+86', country: 'China', dialCode: 86 },
  { code: '+90', country: 'Turkey', dialCode: 90 },
  { code: '+91', country: 'India', dialCode: 91 },
  { code: '+92', country: 'Pakistan', dialCode: 92 },
  { code: '+93', country: 'Afghanistan', dialCode: 93 },
  { code: '+94', country: 'Sri Lanka', dialCode: 94 },
  { code: '+95', country: 'Myanmar', dialCode: 95 },
  { code: '+98', country: 'Iran', dialCode: 98 },
  { code: '+212', country: 'Morocco', dialCode: 212 },
  { code: '+213', country: 'Algeria', dialCode: 213 },
  { code: '+216', country: 'Tunisia', dialCode: 216 },
  { code: '+218', country: 'Libya', dialCode: 218 },
  { code: '+220', country: 'Gambia', dialCode: 220 },
  { code: '+221', country: 'Senegal', dialCode: 221 },
  { code: '+222', country: 'Mauritania', dialCode: 222 },
  { code: '+223', country: 'Mali', dialCode: 223 },
  { code: '+224', country: 'Guinea', dialCode: 224 },
  { code: '+225', country: 'Ivory Coast', dialCode: 225 },
  { code: '+226', country: 'Burkina Faso', dialCode: 226 },
  { code: '+227', country: 'Niger', dialCode: 227 },
  { code: '+228', country: 'Togo', dialCode: 228 },
  { code: '+229', country: 'Benin', dialCode: 229 },
  { code: '+230', country: 'Mauritius', dialCode: 230 },
  { code: '+231', country: 'Liberia', dialCode: 231 },
  { code: '+232', country: 'Sierra Leone', dialCode: 232 },
  { code: '+233', country: 'Ghana', dialCode: 233 },
  { code: '+234', country: 'Nigeria', dialCode: 234 },
  { code: '+235', country: 'Chad', dialCode: 235 },
  { code: '+236', country: 'Central African Republic', dialCode: 236 },
  { code: '+237', country: 'Cameroon', dialCode: 237 },
  { code: '+238', country: 'Cape Verde', dialCode: 238 },
  { code: '+239', country: 'Sao Tome and Principe', dialCode: 239 },
  { code: '+240', country: 'Equatorial Guinea', dialCode: 240 },
  { code: '+241', country: 'Gabon', dialCode: 241 },
  { code: '+242', country: 'Republic of the Congo', dialCode: 242 },
  { code: '+243', country: 'Democratic Republic of the Congo', dialCode: 243 },
  { code: '+244', country: 'Angola', dialCode: 244 },
  { code: '+245', country: 'Guinea-Bissau', dialCode: 245 },
  { code: '+246', country: 'British Indian Ocean Territory', dialCode: 246 },
  { code: '+248', country: 'Seychelles', dialCode: 248 },
  { code: '+249', country: 'Sudan', dialCode: 249 },
  { code: '+250', country: 'Rwanda', dialCode: 250 },
  { code: '+251', country: 'Ethiopia', dialCode: 251 },
  { code: '+252', country: 'Somalia', dialCode: 252 },
  { code: '+253', country: 'Djibouti', dialCode: 253 },
  { code: '+254', country: 'Kenya', dialCode: 254 },
  { code: '+255', country: 'Tanzania', dialCode: 255 },
  { code: '+256', country: 'Uganda', dialCode: 256 },
  { code: '+257', country: 'Burundi', dialCode: 257 },
  { code: '+258', country: 'Mozambique', dialCode: 258 },
  { code: '+260', country: 'Zambia', dialCode: 260 },
  { code: '+261', country: 'Madagascar', dialCode: 261 },
  { code: '+262', country: 'Reunion', dialCode: 262 },
  { code: '+263', country: 'Zimbabwe', dialCode: 263 },
  { code: '+264', country: 'Namibia', dialCode: 264 },
  { code: '+265', country: 'Malawi', dialCode: 265 },
  { code: '+266', country: 'Lesotho', dialCode: 266 },
  { code: '+267', country: 'Botswana', dialCode: 267 },
  { code: '+268', country: 'Swaziland', dialCode: 268 },
  { code: '+269', country: 'Comoros', dialCode: 269 },
  { code: '+290', country: 'Saint Helena', dialCode: 290 },
  { code: '+291', country: 'Eritrea', dialCode: 291 },
  { code: '+297', country: 'Aruba', dialCode: 297 },
  { code: '+298', country: 'Faroe Islands', dialCode: 298 },
  { code: '+299', country: 'Greenland', dialCode: 299 },
  { code: '+350', country: 'Gibraltar', dialCode: 350 },
  { code: '+351', country: 'Portugal', dialCode: 351 },
  { code: '+352', country: 'Luxembourg', dialCode: 352 },
  { code: '+353', country: 'Ireland', dialCode: 353 },
  { code: '+354', country: 'Iceland', dialCode: 354 },
  { code: '+355', country: 'Albania', dialCode: 355 },
  { code: '+356', country: 'Malta', dialCode: 356 },
  { code: '+357', country: 'Cyprus', dialCode: 357 },
  { code: '+358', country: 'Finland', dialCode: 358 },
  { code: '+359', country: 'Bulgaria', dialCode: 359 },
  { code: '+370', country: 'Lithuania', dialCode: 370 },
  { code: '+371', country: 'Latvia', dialCode: 371 },
  { code: '+372', country: 'Estonia', dialCode: 372 },
  { code: '+373', country: 'Moldova', dialCode: 373 },
  { code: '+374', country: 'Armenia', dialCode: 374 },
  { code: '+375', country: 'Belarus', dialCode: 375 },
  { code: '+376', country: 'Andorra', dialCode: 376 },
  { code: '+377', country: 'Monaco', dialCode: 377 },
  { code: '+378', country: 'San Marino', dialCode: 378 },
  { code: '+380', country: 'Ukraine', dialCode: 380 },
  { code: '+381', country: 'Serbia', dialCode: 381 },
  { code: '+382', country: 'Montenegro', dialCode: 382 },
  { code: '+383', country: 'Kosovo', dialCode: 383 },
  { code: '+385', country: 'Croatia', dialCode: 385 },
  { code: '+386', country: 'Slovenia', dialCode: 386 },
  { code: '+387', country: 'Bosnia and Herzegovina', dialCode: 387 },
  { code: '+389', country: 'North Macedonia', dialCode: 389 },
  { code: '+420', country: 'Czech Republic', dialCode: 420 },
  { code: '+421', country: 'Slovakia', dialCode: 421 },
  { code: '+423', country: 'Liechtenstein', dialCode: 423 },
  { code: '+500', country: 'Falkland Islands', dialCode: 500 },
  { code: '+501', country: 'Belize', dialCode: 501 },
  { code: '+502', country: 'Guatemala', dialCode: 502 },
  { code: '+503', country: 'El Salvador', dialCode: 503 },
  { code: '+504', country: 'Honduras', dialCode: 504 },
  { code: '+505', country: 'Nicaragua', dialCode: 505 },
  { code: '+506', country: 'Costa Rica', dialCode: 506 },
  { code: '+507', country: 'Panama', dialCode: 507 },
  { code: '+508', country: 'Saint Pierre and Miquelon', dialCode: 508 },
  { code: '+509', country: 'Haiti', dialCode: 509 },
  { code: '+590', country: 'Guadeloupe', dialCode: 590 },
  { code: '+591', country: 'Bolivia', dialCode: 591 },
  { code: '+592', country: 'Guyana', dialCode: 592 },
  { code: '+593', country: 'Ecuador', dialCode: 593 },
  { code: '+594', country: 'French Guiana', dialCode: 594 },
  { code: '+595', country: 'Paraguay', dialCode: 595 },
  { code: '+596', country: 'Martinique', dialCode: 596 },
  { code: '+597', country: 'Suriname', dialCode: 597 },
  { code: '+598', country: 'Uruguay', dialCode: 598 },
  { code: '+599', country: 'Netherlands Antilles', dialCode: 599 },
  { code: '+670', country: 'East Timor', dialCode: 670 },
  { code: '+672', country: 'Antarctica', dialCode: 672 },
  { code: '+673', country: 'Brunei', dialCode: 673 },
  { code: '+674', country: 'Nauru', dialCode: 674 },
  { code: '+675', country: 'Papua New Guinea', dialCode: 675 },
  { code: '+676', country: 'Tonga', dialCode: 676 },
  { code: '+677', country: 'Solomon Islands', dialCode: 677 },
  { code: '+678', country: 'Vanuatu', dialCode: 678 },
  { code: '+679', country: 'Fiji', dialCode: 679 },
  { code: '+680', country: 'Palau', dialCode: 680 },
  { code: '+681', country: 'Wallis and Futuna', dialCode: 681 },
  { code: '+682', country: 'Cook Islands', dialCode: 682 },
  { code: '+683', country: 'Niue', dialCode: 683 },
  { code: '+685', country: 'Samoa', dialCode: 685 },
  { code: '+686', country: 'Kiribati', dialCode: 686 },
  { code: '+687', country: 'New Caledonia', dialCode: 687 },
  { code: '+688', country: 'Tuvalu', dialCode: 688 },
  { code: '+689', country: 'French Polynesia', dialCode: 689 },
  { code: '+690', country: 'Tokelau', dialCode: 690 },
  { code: '+691', country: 'Micronesia', dialCode: 691 },
  { code: '+692', country: 'Marshall Islands', dialCode: 692 },
  { code: '+850', country: 'North Korea', dialCode: 850 },
  { code: '+852', country: 'Hong Kong', dialCode: 852 },
  { code: '+853', country: 'Macau', dialCode: 853 },
  { code: '+855', country: 'Cambodia', dialCode: 855 },
  { code: '+856', country: 'Laos', dialCode: 856 },
  { code: '+880', country: 'Bangladesh', dialCode: 880 },
  { code: '+886', country: 'Taiwan', dialCode: 886 },
  { code: '+960', country: 'Maldives', dialCode: 960 },
  { code: '+961', country: 'Lebanon', dialCode: 961 },
  { code: '+962', country: 'Jordan', dialCode: 962 },
  { code: '+963', country: 'Syria', dialCode: 963 },
  { code: '+964', country: 'Iraq', dialCode: 964 },
  { code: '+965', country: 'Kuwait', dialCode: 965 },
  { code: '+966', country: 'Saudi Arabia', dialCode: 966 },
  { code: '+967', country: 'Yemen', dialCode: 967 },
  { code: '+968', country: 'Oman', dialCode: 968 },
  { code: '+970', country: 'Palestine', dialCode: 970 },
  { code: '+971', country: 'United Arab Emirates', dialCode: 971 },
  { code: '+972', country: 'Israel', dialCode: 972 },
  { code: '+973', country: 'Bahrain', dialCode: 973 },
  { code: '+974', country: 'Qatar', dialCode: 974 },
  { code: '+975', country: 'Bhutan', dialCode: 975 },
  { code: '+976', country: 'Mongolia', dialCode: 976 },
  { code: '+977', country: 'Nepal', dialCode: 977 },
  { code: '+992', country: 'Tajikistan', dialCode: 992 },
  { code: '+993', country: 'Turkmenistan', dialCode: 993 },
  { code: '+994', country: 'Azerbaijan', dialCode: 994 },
  { code: '+995', country: 'Georgia', dialCode: 995 },
  { code: '+996', country: 'Kyrgyzstan', dialCode: 996 },
  { code: '+998', country: 'Uzbekistan', dialCode: 998 },
];

export const getDialCode = (countryCode) => {
  const found = countryCodes.find((c) => c.code === countryCode);
  return found ? found.dialCode : 1;
};

export const getCountryName = (countryCode) => {
  const found = countryCodes.find((c) => c.code === countryCode);
  return found ? found.country : 'USA/Canada';
};

export const fetchGeoLocation = async () => {
  if (cachedGeoData) return cachedGeoData;
  try {
    const response = await axios.get(GEOLOCATION_API, {
      headers: { accept: 'text/plain' },
    });
    if (response.data?.isSuccess) {
      cachedGeoData = response.data.data;
      return cachedGeoData;
    }
    return null;
  } catch (error) {
    console.error('GeoLocation fetch error:', error);
    return null;
  }
};

export const getDefaultCountryCode = async () => {
  const geo = await fetchGeoLocation();
  if (geo?.countryCode) {
    const matched = countryCodes.find(
      (c) =>
        c.country.toLowerCase().includes(geo.countryName?.toLowerCase()) ||
        c.code === `+${geo.countryCode}`
    );
    if (matched) return matched.code;
  }
  return '+1';
};

export const submitLead = async (formData, options = {}) => {
  const {
    source = 'website',
    pageUrl = window.location.href,
    packageTitle = 'Essentials',
    packageAmount = 45,
    tmSignUpType,
    onSuccess,
    onError,
  } = options;

  try {
    const geoData = await fetchGeoLocation();

    const countryDialCode = getDialCode(formData.country_code);
    const countryName = geoData?.countryCode || getCountryName(formData.country_code);

    const phoneNumber = formData.contact_number.replace(/\D/g, '');

    const payload = {
      name: formData.name,
      email: formData.email,
      countryDialCode: countryDialCode,
      country: countryName,
      phoneNumber: phoneNumber,
      ipAddress: geoData?.ipAddress || '',
      description: formData.message || '',
      pageUrl: pageUrl,
      city: geoData?.cityName || '',
      state: geoData?.regionName || '',
      geoLocation: geoData ? JSON.stringify({
        isSuccess: true,
        data: geoData,
        errorMessage: '',
        statusCode: 200,
      }) : '',
      packageTitle: packageTitle,
      packageAmount: packageAmount,
      ...(tmSignUpType && { tmSignUpType }),
    };

    const response = await axios.post(LEAD_API, payload, {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
    });

    const data = response.data;

    if (data.statusCode === 200 && data.data?.customerId) {
      toast.success(data.data.message || 'Lead created successfully');
      if (onSuccess) onSuccess(data.data);
      return { success: true, data: data.data };
    }

    if (data.statusCode === 401) {
      const msg = data.message || 'Unauthorized request';
      toast.error(msg);
      if (onError) onError(msg);
      return { success: false, error: msg };
    }

    if (data.statusCode === 400 || data.isSuccess === false) {
      const msg = data.errorMessage || data.data?.message || 'Invalid request';
      toast.error(msg);
      if (onError) onError(msg);
      return { success: false, error: msg };
    }

    return { success: true, data: data.data };
  } catch (error) {
    const msg = error.response?.data?.message || error.response?.data?.errorMessage || 'Failed to submit form. Please try again.';
    toast.error(msg);
    if (onError) onError(msg);
    return { success: false, error: msg };
  }
};
